// banner de cookies do Privacy Tools (biblioteca cookieconsent)
const COOKIE_BANNER_SELECTOR = '#privacytools-banner-consent, .cc-window';

export function getCookieBannerHeight(): number {
  const banner = document.querySelector<HTMLElement>(COOKIE_BANNER_SELECTOR);
  if (!banner) return 0;

  const style = window.getComputedStyle(banner);
  if (
    style.display === 'none' ||
    style.visibility === 'hidden' ||
    banner.classList.contains('cc-invisible')
  ) {
    return 0;
  }

  return Math.ceil(banner.getBoundingClientRect().height);
}
